import React from 'react';
import { useTranslation } from 'react-i18next';
import { SupportedLanguage, supportedLanguages } from '../i18n';

export const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();
  const currentLanguage = (i18n.language?.startsWith('de') ? 'de' : 'en') as SupportedLanguage;

  return (
    <div className="flex items-center gap-1 text-sm">
      {supportedLanguages.map((lng, index) => (
        <span key={lng} className="flex items-center">
          {index > 0 && (
            <span className="mx-1" style={{ color: 'var(--border)' }}>|</span>
          )}
          <button
            onClick={() => i18n.changeLanguage(lng)}
            className="px-1 py-0.5 rounded transition-colors cursor-pointer"
            style={{
              color: currentLanguage === lng ? 'var(--navy)' : 'var(--text-muted)',
              fontWeight: currentLanguage === lng ? 600 : 400,
            }}
          >
            {lng.toUpperCase()}
          </button>
        </span>
      ))}
    </div>
  );
};
